// Theme data in a separate module so it can be imported by the web app without
// bringing other Node modules along with it.

import defaultTheme from 'tailwindcss/defaultTheme';
import type { Config } from 'tailwindcss';

export const theme = {
    extend: {
        fontFamily: {
            sans: [`Mona Sans`, ...defaultTheme.fontFamily.sans],
            mono: [`Space Mono`, ...defaultTheme.fontFamily.mono],
            display: [`PP Museum`, ...defaultTheme.fontFamily.sans]
        },
        colors: {
            sb: {
                // Deprecated colors:
                bg: `#F5F8FF`,
                frame: `#FBF9F9`
            },
            blue: {
                // Deprecated colors:
                on: `#083661`,
                over: `#0E5EAA`,
                text: `#1B55A6`,

                // From SDS:
                950: `#0A2747`,
                900: `#0E3761`,
                800: `#0B4881`,
                700: `#08529C`,
                600: `#0969C0`,
                500: `#1686E1`,
                400: `#3FA1F1`,
                300: `#BCDCFB`,
                200: `#BCDCFB`,
                100: `#E1EEFD`,
                50: `#F5FAFF`
            },
            neutral: {
                1000: `#171B20`,
                950: `#222933`,
                900: `#313B49`,
                800: `#364556`,
                700: `#3E5066`,
                600: `#4C637D`,
                500: `#607C97`,
                400: `#8098B0`,
                300: `#ADBCCC`,
                200: `#D3DBE4`,
                100: `#EBEEF3`,
                50: `#F9FAFC`,
                0: `#FFFFFF`
            },
            red: {
                700: `#CA0B0B`,
                600: `#E10E0E`,
                500: `#FF3131`,
                300: `#FF9B9B`,
                100: `#FFDFDF`,
                50: `#FFF1F1`
            },
            orange: {
                700: `#AE5220`,
                600: `#D26C24`,
                400: `#E69E51`,
                300: `#FDC373`,
                100: `#FAEEDA`,
                50: `#FDF8EF`
            },
            green: {
                700: `#1B7A44`,
                600: `#22AD5C`,
                500: `#2CBB68`,
                300: `#8CE9B3`,
                100: `#DEFAE9`,
                50: `#F1FCF5`
            },
            header: `#1b70bb` // Deprecated
        },
        minHeight: {
            sb: `600px`
        },
        boxShadow: {
            sb: `0px 0px 6px rgba(0, 0, 0, 0.25)`,
            dark: `0px 0px 6px rgba(0, 0, 0, 0.6)`
        }
    }
} satisfies Config[`theme`];
